import { cloneDeep } from 'lodash';

import { MITIGANT_FACTOR, PAYMENT_ISSUES_TYPE, SIGNIFICANT_CHANGES_TYPE } from '@funnels/constants';
import { FinancialSituation } from '@funnels/types';

export const FINANCIAL_SITUATION_MOCK_DATA: FinancialSituation[] = [
  {
    applicantId: 'applicant-1',
    applicationId: 'application-1',
    id: 'financialSituation-1',
    clientId: 'financialSituation-1-client',
    mitigant: [
      {
        factor: MITIGANT_FACTOR.ApplicationReflectsChanges,
        description: 'mitigant-description',
      },
    ],
    paymentIssues: [
      {
        type: PAYMENT_ISSUES_TYPE.HardshipArrangements,
        description: 'payment-issues-description',
      },
    ],
    retirementDetails: {
      age: 65,
      description: 'retirement-age',
    },
    significantChanges: [
      {
        type: SIGNIFICANT_CHANGES_TYPE.ExtendedUnpaidLeave,
      },
    ],
  },
  {
    applicantId: 'applicant-2',
    applicationId: 'application-2',
    id: 'financialSituation-2',
    clientId: 'financialSituation-2-client',

    mitigant: [
      {
        factor: MITIGANT_FACTOR.CoApplicantsIncome,
        description: 'mitigant-description',
      },
    ],
    paymentIssues: [
      {
        type: PAYMENT_ISSUES_TYPE.None,
        description: 'payment-issues-description',
      },
    ],
    retirementDetails: {
      age: 70,
      description: 'retirement-age',
    },
    significantChanges: [
      {
        type: SIGNIFICANT_CHANGES_TYPE.PermanentDecreaseInIncome,
      },
    ],
  },
  {
    applicantId: 'applicant-3',
    applicationId: 'application-3',
    id: 'financialSituation-3',
    clientId: 'financialSituation-3-client',
    mitigant: [
      {
        factor: MITIGANT_FACTOR.CoApplicantsIncome,
        description: 'mitigant-description',
      },
    ],
    paymentIssues: [
      {
        type: PAYMENT_ISSUES_TYPE.None,
        description: 'payment-issues-description',
      },
    ],
    retirementDetails: {
      age: 60,
      description: 'retirement-age',
    },
    significantChanges: [
      {
        type: SIGNIFICANT_CHANGES_TYPE.PermanentDecreaseInIncome,
      },
    ],
  },
  {
    applicantId: 'applicant-7',
    applicationId: 'application-1',
    id: 'financialSituation-7',
    clientId: 'financialSituation-7-client',
    mitigant: [
      {
        factor: MITIGANT_FACTOR.ApplicationReflectsChanges,
        description: 'mitigant-description',
      },
    ],
    paymentIssues: [
      {
        type: PAYMENT_ISSUES_TYPE.HardshipArrangements,
        description: 'payment-issues-description',
      },
    ],
    retirementDetails: {
      age: 65,
      description: 'retirement-age',
    },
    significantChanges: [
      {
        type: SIGNIFICANT_CHANGES_TYPE.ExtendedUnpaidLeave,
      },
    ],
  },
];

export const getMockFinancialSituations = (): FinancialSituation[] => cloneDeep(FINANCIAL_SITUATION_MOCK_DATA);
